module.exports = __webpack_public_path__ + "img/eye-icon-white.699e46b4.svg";